import { DownloadOutlined } from '@ant-design/icons'
import { Col, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { UploadFileResponse } from '../../../../../redux/api/apiTypes';
import { useLazyGetFileByObjectIdAndTypeQuery } from '../../../../../redux/api/FileApi';
import { exportFile } from '../../../../common/ts/CommonFunctions';
import { fileTypes } from '../../../../common/types/types';
import { AuctionResponse } from '../../../types';

interface DetailProps {
    item?: AuctionResponse
}

const TabContent3 = ({ item }: DetailProps) => {
    const [trigger] = useLazyGetFileByObjectIdAndTypeQuery();
    const [fileList, setFileList] = useState<UploadFileResponse[]>([]);

    useEffect(() => {
        if (item?.productId) {
            let promises = [
                trigger({
                    objectId: item.productId,
                    objectType: fileTypes.PRODUCT,
                }).unwrap(),
                trigger({
                    objectId: item.productId,
                    objectType: fileTypes.OTHER_DOCUMENT,
                    storageType: "isPublic"
                }).unwrap()
            ]

            Promise.all(promises).then((res) => {
                let newFileList: UploadFileResponse[] = [];
                res.forEach(resItem => {
                    if (resItem.length) {
                        newFileList = newFileList.concat(resItem);
                    }
                })
                setFileList(newFileList);
            })

        }
    }, [trigger, item])

    const downloadFile = (id: number, fileName: string) => {
        exportFile(process.env.REACT_APP_API_URL + "/files/downloadFile/" + id, fileName);
    }

    return (
        <div>
            <Row justify='center' gutter={[0, 10]}>
                {fileList?.length ?
                    fileList.map(responseItem => (
                        <Col xs={14} key={responseItem.attachmentId}>
                            <div className="rules-box">
                                <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {responseItem.fileName}
                                </div>
                                <div style={{ cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={() => downloadFile(responseItem.attachmentId, responseItem.fileName)}>
                                    <DownloadOutlined />
                                    <span style={{ marginLeft: 5, color: '#4F83D8' }}>Tải xuống</span>
                                </div>
                            </div>
                        </Col>
                    ))
                    : <></>
                }
            </Row>


        </div>
    )
}

export default TabContent3